export enum LocationTypeEnum {
  INTERNAL = "internal",
  EXTERNAL = "external",
}
